


























































































































import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';
import ChunkUploader from '../ChunkUploader/ChunkUploader.vue';
import * as signalR from "@microsoft/signalr";    
import HelpContent from '../HelpContent.vue';
import store from '@/services/Store';

@Component({
    components: {
        ChunkUploader,
        HelpContent
    }
})
export default class DocumentationDownload extends Vue {
    file: any = [];
    importProcessList = [];
    uploading: boolean = false;        
    uploadComplete: boolean = false;        
    GENERICFilter : boolean = false;
    PDSFilter : boolean = false;
    PDSDOCXFilter : boolean = false;
    SDSFilter : boolean = false;
    fileName: string = null;
    uploadPerc : number = 0;
    chunkSize: number = 300;
    idSession: string = "";
    general: any = {};
    documentUploaded : boolean = false;
    connection: any;
    idProcess: string = "";
    zipPath: boolean = false;
    createdProcess: boolean = false;
    showProcessing: boolean = false;
    showRequestNewDocument: boolean = false;

    mounted() {
        this.general = General;
        this.importProcessList = [];
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(General.GetApiUrl('/message'))
            .build();

        let app = this;

        this.connection.on("status", data => {
            var dataParsed = JSON.parse(data);
           

            app.importProcessList =  General.filterProcess(dataParsed);

            var currentCompleted = dataParsed.filter(x=>x.ProcessId==app.idProcess && x.Status=='complete');
            var currentCompletedError = dataParsed.filter(x=>x.ProcessId==app.idProcess && x.Status=='error');
            /*console.log("----")
            console.log(currentCompleted.length)
            console.log(dataParsed)*/
            if (currentCompleted.length>0 || currentCompletedError.length>0) {
                app.connection.stop();
                app.showRequestNewDocument = true;
            }
            
        });
        
    }
    
    filterProcess(dataParsed){
        return dataParsed.filter((el:any)=>{
            return el.Username==store.getters.getUser.Username

        })

    }

    updateProgress(e: any) {
        this.uploadPerc = e;
    }
    async uploadCompleted(sessionId: any) {
        let app = this;
        //setTimeout(async ()=>{
        
            
            app.documentUploaded = true;
            
        //},1000);
        this.idSession = sessionId;
        this.uploadPerc = 100;
        await this.searchZip();
    }
    getFileName(fileName: string) {
        this.fileName = fileName;
    }
    
    async searchZip() {
        this.connection.start();
        this.uploading = true;
        this.uploadComplete = false;
        let app = this;
        this.createdProcess = false;
        //console.log(this.file)
        try{
            let responseProcess = await axios({
                method: 'get',
                url: General.GetApiUrl('/api/Document/CreateProcessForZipDownload'),
                withCredentials: true
            });

            
            this.idProcess = responseProcess.data;
            this.createdProcess = true;
        }
        catch(error){
            
            
            if (error.response.status==404){
                
                General.showAlertInfo(this.$t('PRODUCT.ANOTHER_PROCESS_RUNNING') as string, this);
                 
            }else{
                General.HandleError(error, this);    
            }                
         
        }
        
        if (this.createdProcess==true){
            try {
            
                let response = await axios({
                    method: 'post',
                    url: General.GetApiUrl('/api/Document/GetZipDocumentsByProductExcel'),
                    data: {GENERIC : this.GENERICFilter,
                            PDS : this.PDSFilter,
                            PDSDOCX : this.PDSDOCXFilter,
                            SDS: this.SDSFilter,
                            IdSession: this.idSession, 
                            ProcessId: this.idProcess},
                    withCredentials: true,
                    responseType: 'json'
                });
                if (response.data==null) {
                //    General.showAlertSuccess("Zip File requested is ready!", app);
                //    this.zipPath = true;
                    
                }
                else {
                    let error = "";
                    for (let i = 0; i < response.data.errors.length; i++) {
                        error += response.data.errors[i] + "<br/>";
                    }
                    if (response.status==200){
                        alert("in coda")
                    }else{
                        General.showAlertDangerAsHTML(error, app);
                    }
                    
                }
                
                
            }catch(error){
                General.HandleError(error, this);
                this.onUploadComplete();
            }    
        }
    }

    forceCancel(process: any) {
        axios({
            method: 'post',
            url: General.GetApiUrl('/api/process/ForceEndTask?user=' + this.$store.state.user.Username + '&processId=' + process.ProcessId),
            withCredentials: true,
            responseType: 'json'
        })
            .then(({ data }) => {
            });
        console.log("cancella task " + process.ProcessId)
        this.onUploadComplete();
    }

    forceCancelProcessId(processId: any) {
        axios({
            method: 'post',
            url: General.GetApiUrl('/api/process/ForceEndTask?user=' + this.$store.state.user.Username + '&processId=' + processId),
            withCredentials: true,
            responseType: 'json'
        })
            .then(({ data }) => {
            });
        console.log("cancella task " + processId)
        this.onUploadComplete();
    }

    readProcessError(errors: string) {
        let errorList = errors.split('|');
        return errorList;
    }

    get getUrl(){
        return General.GetApiUrl('/api/Document/ForceDownloadZip?idSession='+this.idSession);
    }
    
    async forceDownload(){
        let app = this;
        console.log(this.idSession);
        window.open(General.GetApiUrl('/api/Document/DownloadZip?idSession='+this.idSession), '_blank');
        
        
    }

    onUploadComplete() {
        this.uploading = false;
        this.uploadComplete = true;
        this.uploadPerc = 0;
        this.reset();
    }
    reset() {
        this.uploading = false;
        this.uploadComplete = false;
        this.importProcessList = [];
        this.idProcess = "";
        this.documentUploaded = false;
        this.PDSFilter = false;
        this.SDSFilter = false;
        this.PDSDOCXFilter = false;
        this.GENERICFilter = false;
        this.zipPath = false;
        this.fileName = "";
        this.createdProcess = false;
        this.showRequestNewDocument = false;
        this.connection.stop();
    }

    getDownloadDocumentSpecUrl(){
        let url = General.GetApiUrl('/api/document/DownloadDocumentSpecUrl');
        return url;
    }
}
